import React, { Component } from 'react';
import CustomerDashboardView from './CustomerDashboardView';
import { url } from '../../../Server/url/GlobalUrl'


class CustomerDashboardComponent extends Component {

    state = {
        job_detail : [],
        shift_detail: [],
        application_detail: [],
        shift_modal_show: false,
        modal_table_show:false,
        contract_type_arr:{1:'Emergency',2:'Temporary',3:'Permanent'},
    }

    handleshift = (id) => {
        console.log('id',id)
        this.setState({'shift_modal_show' : true})
        var token = localStorage.getItem("token")
        fetch((url + "/jobs/job-post/" + id + '/'), {
            method: 'GET',
             headers: {
               'Accept': 'application/json',
               'Content-Type': 'application/json',
               'Authorization': 'Bearer ' + token,
            },
            })
          .then(res => res.json())
          .then(
            (result) => {
                console.log('result',result)
                this.setState({
                        shift_detail : result.shifts
                    })
                   
                 
            })
            console.log('result.shifts',this.state.shift_detail)

}

hideShiftModal = () => {
    this.setState({ shift_modal_show: false })
}

showShiftModal = () => {
    this.setState({ shift_modal_show: true })
}

    componentDidMount() {
        let auth = localStorage.getItem("token")
		fetch((url + "/jobs/admin-jobs/?active=true"), {
                method: 'GET',
                 headers: {
                   'Accept': 'application/json',
                  'Content-Type': 'application/json',
                  'Authorization': 'Bearer ' + auth,
                },
                })
              .then(res => res.json())
              .then(
		        (result) => {
		        console.log('result_btao',result)
		        if (result.detail === 'Given token not valid for any token type' || result.detail === 'User not found'){
		          this.setState({jobs: []})
		          localStorage.removeItem('token')
		          window.location.replace('/login')
                   }
                else{
                    this.setState({'job_detail' : result})
                    var i;
                    for (i = 0; i < this.state.job_detail.length; i++) {
                        
                        this.state.job_detail[i]['shift_count'] = this.state.job_detail[i].shifts.length
                    }
                    console.log('job_detail',this.state.job_detail)
                    this.setState({job_detail :this.state.job_detail})
                    }
                })

    }

    handleShift =(data) =>{
        console.log(data);
        this.setState({shifts:data})
    }

    handleShiftCloseModal =()=>{
        this.setState({showShiftModal: false});
    }

    handleShiftShowModal=()=>{
        this.setState({showShiftModal: true});
    }

    hideTableModal = () => {
        this.setState({ modal_table_show: false })
    }

    showTableModal = () => {
        this.setState({ modal_table_show: true })
    }

    handlepreview = (id) => {
        console.log('id', id)
        let url = '/job-details/' + id
        window.location.replace(url)
    }

    handledelete = (id) => {
        console.log('hello all deleted', id)
        var token = localStorage.getItem("token")
        fetch((url + "/jobs/job-post/" + id + '/'), {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
        })
            .then((response) => {
                console.log("response", response)
                if (response['status'] === 201 || response['status'] === 200 || response['status'] === 204) {
                    this.showCustomModal()
                    this.setState({ authResponse: 'Deleted Successfully' })
                    fetch((url + "/jobs/job-post/?job_type=private&status=Pending"), {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + token,
                        },
                    })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                if (result.length > 0) {
                                    console.log('result', result)
                                    this.setState({
                                        job_detail: result
                                    })
                                }
                                fetch((url + "/jobs/admin-jobs/?job_type=private&status=Booking"), {
                                    method: 'GET',
                                    headers: {
                                        'Accept': 'application/json',
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Bearer ' + token,
                                    },
                                })
                                    .then(res => res.json())
                                    .then(
                                        (result) => {
                                            console.log('result', result)
                                            if (result.length > 0) {
                                                var i;
                                                for (i of result) {
                                                    this.state.job_detail.push(i)

                                                }
                                                this.setState({
                                                    job_detail: this.state.job_detail
                                                })
                                            }
                                        })
                            })
                } else if (response['status'] === 400) {
                    this.showCustomModal()
                    this.setState({ authResponse: 'Something went wrong please try again' })
                }
            })
    }

    handleapplicant = (id) => {
        console.log('id', id)
         let auth = localStorage.getItem("token")
        fetch((url + "/jobs/admin-jobs/" + id+"/"), {
                        method: 'GET',
                         headers: {
                           'Accept': 'application/json',
                           'Content-Type': 'application/json',
                           'Authorization': 'Bearer ' + auth,
                        },
                        })
                      .then(res => res.json())
                      .then(
                        (result) => {
                            console.log('result',result)

                            if (result){
                             // var i;
                             //    for (i of result) {
                             //        var day = moment(result.date_applied).format("MMMM DD, YYYY")
                             //        i['date_applied'] = day
                             //        console.log('day',day)

                             //    }
                                console.log('check status',result)
                                 this.setState({
                                application_detail : result
                            })
                            this.showTableModal()

                             }

                        })

                        fetch((url + "/api/v1/user/admin-jobs-applied-users/?job_id=" + id), {
                            method: 'GET',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + auth,
                            },
                        })
                            .then(res => res.json())
                            .then(
                                (result) => {
                                    console.log('candidate__________details', result)
                
                                    if (result.length>0) {
                                        this.setState({
                                            application_detail: { ...this.state.application_detail, ["eligible_candidates"]: result }
                                        })
                                        this.showTableModal()
                                    }
                                    console.log("++++",this.state.application_detail)
                                })
                

    }



 render() {
        return (
            <CustomerDashboardView
                jobs =  {this.state.job_detail}
                hideShiftModal={this.hideShiftModal}
                showShiftModal={this.showShiftModal}
                hideTableModal={this.hideTableModal}
                shift_modal_show={this.state.shift_modal_show}
                handleshift={this.handleshift}
                handleapplicant={this.handleapplicant}
                handlepreview={this.handlepreview}
                handledelete={this.handledelete}
                shift_detail={this.state.shift_detail}
                contract_type_arr={this.state.contract_type_arr}
                modal_table_show={this.state.modal_table_show}
                application_detail={this.state.application_detail}
            />

        )
    }

}

export default CustomerDashboardComponent;